import { Icon } from 'AppStyles';
import { Container, Message } from './Styles';
import success from 'assets/svg/success.svg';
import info from 'assets/svg/info.svg';

const status = {
  pending: {
    icon: info,
    message: 'Pending Purchase.',
    color: '#4892e1',
  },
  success: {
    icon: success,
    message: 'Successful Purchase!',
    color: '#1aba7c',
  },
  error: {
    icon: info,
    message: 'Sorry, seems like something gone wrong, try again.',
    color: '#e14870',
  },
};

const Status = ({ type }) => {
  const { icon, message, color } = status[type];
  return (
    <Container $color={color}>
      <Icon src={icon} width={35} />
      <Message>{message}</Message>
    </Container>
  );
};

export default Status;
